import { ActionTypes } from "../../../constants/ActionConstants";

// These below actions are for "Target-Group" form
export const resetTgSpecificOts = () => ({
  type: ActionTypes.CampaignPlanner.RESET_TG_SPECIFIC_OTS,
});
